.bottom-row {
    color: var(--grey-lt);
    display: flex;
}

.no-options-message-text {
    color: var(--grey);
}
